<div class="navbar-header">
    <a class="" rel="home" href="#" title="">
        <img class="responsive" style="width:100%;height: auto;"
             src="assets/images/header-1.png">
    </a>
</div>
<section id="header" class="rounded" style="margin-top:1%;background-color:white;text-align: center;text-emphasis-color: inherit"><strong> St. Xavier International School, Bhubaneswar</strong>
    <div class="container">
        <div class="row" >
            <div class="col-md-12 col-xs-12 col-centered" style="align-items: center;
            text-decoration: underline;">
            <strong>Online Fee payment</strong></div>
        </div>
    </div>
</section>
<div class="card" style="margin-top: 1%">
<h4 class="card-header">Student Fee Details</h4>


  <div class="form-group" style="padding:20px 100px 0px 100px;">
    <mat-form-field (focus)="hideError('studentType')" class="mt5 wrapper"style= "width:100%" >
      <mat-label> Select Student Type </mat-label>
      <mat-select matInput #studDtls panelClass="testClass" autocomplete="off" required (selectionChange)="onStudentTypeChange(studDtls)">
          <mat-option value="NEW"> NEW </mat-option>
          <mat-option value="EXISTING">EXISTING</mat-option>
        </mat-select>
      </mat-form-field>
</div>

<div class="card-body"  *ngIf="studentType=='EXISTING'">
    <form [formGroup]="form" (ngSubmit)="onSub()">

    <div class="xavierstudentDetailsDiv">

   
      <div class="form-group">
        <mat-form-field (focus)="hideError('schoolBranch')" class="mt5 wrapper"style="width:100%" >
          <mat-label> Select School Branch </mat-label>
          <mat-select matInput formControlName="schoolBranch" panelClass="testClass" autocomplete="off" required >
              <mat-option value="Satyanagar Branch">Satyanagar Branch</mat-option>
              <mat-option value="Satyavihar Branch">Satyavihar Branch</mat-option>
              <mat-option value="Patia Branch">Patia Branch</mat-option>
              <mat-option value="Malipada Branch">Malipada Branch</mat-option>
              <mat-option value="Gangapada Branch">Gangapada Branch</mat-option>
              <mat-option value="Daruthenga Branch">Daruthenga Branch</mat-option>    
            </mat-select>
            <mat-error *ngIf="form.controls['schoolBranch'].hasError('required')">School Branch is required</mat-error>
          </mat-form-field>
      </div>  

        <div class="form-group">
          <mat-form-field (focus)="hideError('studentClass')" class="mt5 wrapper"style="width:100%" >
            <mat-label> Select Class </mat-label>
            <mat-select matInput formControlName="studentClass" panelClass="testClass" autocomplete="off" required >
                   <mat-option value="I">I</mat-option>
                    <mat-option value="II">II</mat-option>
                    <mat-option value="III">III</mat-option>
                    <mat-option value="IV">IV</mat-option>
                    <mat-option value="V">V</mat-option>
                    <mat-option value="VI">VI</mat-option>
                    <mat-option value="VII">VII</mat-option>
                    <mat-option value="VIII">VIII</mat-option>
                    <mat-option value="IX">IX</mat-option>
                    <mat-option value="X">X</mat-option>
                    <mat-option value="XI">XI</mat-option>
                    <mat-option value="XII">XII</mat-option> 
              </mat-select>
              <mat-error *ngIf="form.controls['studentClass'].hasError('required')">Class is required.</mat-error>
            </mat-form-field>
        </div>
  
        <div class="form-group">
          <mat-form-field (focus)="hideError('studentSection')" class="mt5 wrapper"style="width:100%" >
            <mat-label> Select Section </mat-label>
            <mat-select matInput formControlName="studentSection" panelClass="testClass" autocomplete="off" required >
                   <mat-option value="A">A</mat-option>
                    <mat-option value="B">B</mat-option>
                    <mat-option value="C">C</mat-option>
                    <mat-option value="D">D</mat-option>
              </mat-select>
              <mat-error *ngIf="form.controls['studentSection'].hasError('required')">Section is required.</mat-error>
            </mat-form-field>
        </div>

        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label>Enter Registration Number </mat-label>
            <input
            type="text"
            maxlength="50"
            matInput
            placeholder="Registration Number"
            formControlName="registrationNo"
            autocomplete="off"
            required/>
            <mat-error *ngIf="form.controls['registrationNo'].hasError('required')">Registration Number is required.</mat-error>
            <mat-error *ngIf="form.controls['registrationNo'].hasError('pattern')">Invalid Registration Number</mat-error>
          </mat-form-field>
        </div>
        
        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Mobile No. </mat-label>
            <input type="text" matInput maxlength="10" placeholder="Mobile No" formControlName="mobileNo" autocomplete="off" required/>
            <mat-error *ngIf="form.get('mobileNo').hasError('required')">Mobile No is Required</mat-error>
            <mat-error *ngIf="form.get('mobileNo').hasError('pattern')">Invalid Mobile No.</mat-error>
          </mat-form-field>
        </div>
  
        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Email Id </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Email Id" formControlName="emailId" autocomplete="off" required/>
            <mat-error *ngIf="form.get('emailId').hasError('required')">Email Id is Required</mat-error>
            <mat-error *ngIf="form.get('emailId').hasError('pattern')">Invalid Email Id</mat-error>
          </mat-form-field>
        </div>
  

        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Re-Admission Fee </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Re-Admission Fee" formControlName="reAdmissionFee" autocomplete="off" />
            <mat-error *ngIf="form.get('reAdmissionFee').hasError('pattern')">Invalid Re-Admission Fee</mat-error>
          </mat-form-field>
        </div> 

        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Course Fee </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Course Fee" formControlName="courseFee" autocomplete="off" />
            <mat-error *ngIf="form.get('courseFee').hasError('pattern')">Invalid Course Fee</mat-error>
          </mat-form-field>
        </div> 



        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Hostel Fee </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Hostel Fee" formControlName="hostelFee" autocomplete="off" />
            <mat-error *ngIf="form.get('hostelFee').hasError('pattern')">Invalid Hostel Fee</mat-error>
          </mat-form-field>
        </div> 

        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Transportation Fee </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Transportation Fee" formControlName="transportationFee" autocomplete="off" />
            <mat-error *ngIf="form.get('transportationFee').hasError('pattern')">Invalid Transportation Fee</mat-error>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Uniform Fee </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Uniform Fee" formControlName="uniformFee" autocomplete="off" />
            <mat-error *ngIf="form.get('uniformFee').hasError('pattern')">Invalid Uniform Fee</mat-error>
          </mat-form-field>
        </div>
  
        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Examination Fee </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Examination Fee" formControlName="examinationFee" autocomplete="off" />
            <mat-error *ngIf="form.get('examinationFee').hasError('pattern')">Invalid Examination Fee</mat-error>
          </mat-form-field>
        </div>
  
        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Late Payment Fee </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Late Payment Fee" formControlName="latePaymentFee" autocomplete="off" />
            <mat-error *ngIf="form.get('latePaymentFee').hasError('pattern')">Invalid Late payment Fee</mat-error>
          </mat-form-field>
        </div>
  
        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Other Fee </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Other Fee" formControlName="otherFee" autocomplete="off" />
            <mat-error *ngIf="form.get('otherFee').hasError('pattern')">Invalid Other Fee</mat-error>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Other Fee Details </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Other Fee Details" formControlName="otherFeeDetails" autocomplete="off" required/>
            <mat-error *ngIf="form.get('otherFeeDetails').hasError('pattern')">Invalid Other Fee Details</mat-error>
          </mat-form-field>
        </div>


  
        <div class="form-group">
          <mat-form-field style="width:100%">
            <mat-label > Enter Total Fee </mat-label>
            <input type="text" matInput maxlength="50" placeholder="Total Fee" [readonly]="true" formControlName="totalFee" value ={{getTotalFee()}} autocomplete="off" />
          </mat-form-field>
        </div>
        </div>

    <div class="col-md-12" style="display: inline-block;">


        <div class="form-group">
                <button [disabled]="loading" (click)="onSub()" style="margin-right:30px;" class="btn btn-primary" >
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Pay Now
                </button>
                <button (click)="redirectHome()" class="btn btn-primary" >
                  BACK TO HOME
                </button>
        </div>
    </div>

    </form>
    <div>
      <form   target="_top" #txnForm [formGroup]="tranxnForm" method="POST" action={{isgPay_url}}  >
        <input type="hidden" [value]="EncDataField"  name="EncData" formControlName="EncData">
        <input type="hidden" [value]="MerchantIdField" name="MerchantId" formControlName="MerchantId">
        <input type="hidden" [value]="BankIdField" name="BankId" formControlName="BankId">
        <input type="hidden" [value]="TerminalIdField" name="TerminalId" formControlName="TerminalId">
        <input type="hidden" [value]="VersionField" name="Version" formControlName="Version">
        <input type="hidden" [value]="TransactionId" name="OrderId" formControlName="TransactionId">
     </form>
     </div>
   </div>
 <div class="card-body" *ngIf="isRecordNotFound" >
  {{res.message}}
  <div class="errBackButtonDiv" style="width: 129px !important; margin-top: 30px;
               margin-bottom: 20px;">
                 <button style="font-size: 13px !important;" class="errBackButton" mat-raised-button (click)="redirectHome()" color="primary">BACK TO HOME</button>
  </div>
</div>
</div>
